import React from "react";

const AttachmentStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 9.95291L11.0948 15.6582C9.24304 17.4473 6.24065 17.4473 4.38885 15.6582C2.53025 13.8625 2.53807 10.9488 4.40629 9.16254L9.85586 3.91811C11.1229 2.69397 13.1771 2.69396 14.4442 3.91808C15.7159 5.14669 15.7105 7.14026 14.4322 8.36251L8.92133 13.6554C8.23736 14.3162 7.12835 14.3162 6.44434 13.6554C5.76032 12.9945 5.76032 11.9231 6.44435 11.2622L11.0079 6.8532",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(AttachmentStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;